export default __webpack_public_path__ + "static/media/capital_section_image_mobile.3b416ddb.jpg";